/* Component Dependencies */
var $ = require( 'jquery' );
var hotelReviewsTemplate = require( 'templates/hotelReviews.hbs' );
var AriesComponent = require( 'libs/aries-component' );

AriesComponent.create({
    type: 'hotelReviews',
    template: {
        'hotelReviews': hotelReviewsTemplate
    }
});
